import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Add token and anti-cache headers to requests (especially for Safari)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Headers anti-caché para Safari
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
    // Agregar timestamp para evitar caché
    config.params = { ...config.params, _t: Date.now() };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Retry logic for network errors (server temporarily down / restarting)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (!config) return Promise.reject(error);
    
    // Only retry on network errors or 502/503/504 (server temporarily down)
    const isRetryable = !error.response || [502, 503, 504].includes(error.response?.status);
    
    // Initialize retry count
    config._retryCount = config._retryCount || 0;
    const isGet = ['get', 'GET'].includes(config.method?.toUpperCase?.() || config.method);
    const maxRetries = isGet ? 3 : 1;
    
    if (isRetryable && config._retryCount < maxRetries) {
      config._retryCount += 1;
      // Exponential backoff: 2s, 4s, 8s
      const delay = Math.min(2000 * Math.pow(2, config._retryCount - 1), 8000);
      await new Promise(resolve => setTimeout(resolve, delay));
      return api(config);
    }
    return Promise.reject(error);
  }
);

export default api;
